<template>
  <v-card>
    <v-card-text>
      <v-layout row>
        <v-flex lg12>
          <v-layout row>
            <v-flex class="py-3 text-xs-right">
              <v-btn class="mr-0 ml-3 my-1"
                     color="default"
                     depressed
                     @click.stop="clearFilters()">
                {{ translation('filters.btn-clear.filters') }}
              </v-btn>
              <v-btn class="mr-0 ml-3 my-1"
                     color="accent"
                     depressed
                     @click.stop="applyFilters()">
                {{ translation('filters.btn-apply.filters') }}
              </v-btn>
            </v-flex>
          </v-layout>
          <!-- time period filters group -->
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left px-4">
              <h3 class="px-2">{{ translation('filter.group.name.time-period') }}</h3>
            </v-flex>
            <v-flex xs-12 class="px-4">
              <!-- filter date time component -->
              <filter-date-time
                @update-filter-date-time="updateFilters">
              </filter-date-time>
            </v-flex>
          </v-layout>
          <!-- filters group wrapper -->
          <v-layout row wrap>
            <!-- filters group start -->
            <v-flex xs12 d-flex>
              <v-expansion-panel class="elevation-0">
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <h3 class="panel--header">{{ translation('filter.group.name.handler') }}</h3>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md4 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "dealer_name"
                            filter-key = "filterDealer"
                            filter-name = "filter.name.dealer"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                        <v-flex xs12 sm6 md4 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "user_name"
                            filter-key = "filterUser"
                            filter-name = "filter.name.user"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <!-- filters group end -->
            <!-- filters group start -->
            <v-flex xs12 d-flex>
              <v-expansion-panel class="elevation-0">
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <h3 class="panel--header">{{ translation('filter.group.name.car') }}</h3>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md4 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "brand_name"
                            filter-key = "filterBrand"
                            filter-name = "filter.name.brand"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                        <v-flex xs12 sm6 md4 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "model_name"
                            filter-key = "filterModel"
                            filter-name = "filter.name.model"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                        <v-flex xs12 sm6 md4 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "car_type"
                            filter-key = "filterCondition"
                            filter-name = "filter.name.car-type"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <!-- filters group end -->
            <!-- filters group start -->
            <v-flex xs12 d-flex>
              <v-expansion-panel class="elevation-0">
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <h3 class="panel--header">{{ translation('filter.group.name.contract') }}</h3>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md4 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "document_type"
                            filter-key = "filterDocumentType"
                            filter-name = "filter.name.document-type"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                        <v-flex xs12 sm6 md4 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "contract_status"
                            filter-key = "filterContractStatus"
                            filter-name = "filter.name.contract-status"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                        <v-flex xs12 sm6 md4 d-flex>
                          <filter-select
                            v-if="renderFilters"
                            filter-id = "payment_type"
                            filter-key = "filterPaymentType"
                            filter-name = "filter.name.payment-type"
                            @update-filters="updateFilters">
                          </filter-select>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <!-- filters group end -->
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
// import filter components
import FilterSelect from '@/components/filters/FilterSelect'
import FilterDateTime from '@/components/filters/FilterDateTimeGen'

const initFilters = [
  {
    outputId: 'dealer_name',
    queryKey: 'filterDealer',
    multiple: true,
    disabled: true,
    type: 'select',
    default: []
  },
  {
    outputId: 'user_name',
    queryKey: 'filterUser',
    multiple: true,
    disabled: true,
    type: 'select',
    default: []
  },
  {
    outputId: 'brand_name',
    queryKey: 'filterBrand',
    multiple: true,
    disabled: true,
    type: 'select',
    default: []
  },
  {
    outputId: 'model_name',
    queryKey: 'filterModel',
    multiple: true,
    disabled: true,
    type: 'select',
    default: []
  },
  {
    outputId: 'car_type',
    queryKey: 'filterCondition',
    multiple: true,
    disabled: true,
    type: 'select',
    default: []
  },
  {
    outputId: 'document_type',
    queryKey: 'filterDocumentType',
    multiple: true,
    disabled: true,
    type: 'select',
    default: []
  },
  {
    outputId: 'contract_status',
    queryKey: 'filterContractStatus',
    multiple: true,
    disabled: true,
    type: 'select',
    default: []
  },
  {
    outputId: 'payment_type',
    queryKey: 'filterPaymentType',
    multiple: true,
    disabled: true,
    type: 'select',
    default: []
  }
]

const timePeriods = [
  { name: 'filter.time-periods.any',
    value: []
  },
  { name: 'filter.time-periods.today',
    value: [
      moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    ]
  },
  { name: 'filter.time-periods.yesterday',
    value: [
      moment().startOf('day').subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('day').subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss')
    ]
  },
  { name: 'filter.time-periods.last-7-days',
    value: [
      moment().startOf('day').subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    ]
  },
  { name: 'filter.time-periods.current-month',
    value: [
      moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
    ],
    default: true
  },
  { name: 'filter.time-periods.last-month',
    value: [
      moment().startOf('month').subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
      moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss')
    ]
  },
  { name: 'filter.time-periods.last-6-months',
    value: [
      moment().startOf('day').subtract(6, 'month').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    ]
  },
  { name: 'filter.time-periods.this-year',
    value: [
      moment().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('year').format('YYYY-MM-DD HH:mm:ss')
    ]
  },
  { name: 'filter.time-periods.last-year',
    value: [
      moment().startOf('year').subtract(1, 'year').format('YYYY-MM-DD HH:mm:ss'),
      moment().endOf('year').subtract(1, 'year').format('YYYY-MM-DD HH:mm:ss')
    ]
  }
]

export default {
  name: 'DashboardVehicleSalePcdFiltersGen',
  components: {
    FilterSelect,
    FilterDateTime
  },
  props: {
    dashboardId: { type: String, required: true }
  },
  data () {
    return {
      renderFilters: false
    }
  },
  computed: {
    ...mapGetters(['selectedFiltersGen', 'translation'])
  },
  created () {
    // set dashboard data with received props
    this.setGeneric(true)
    this.setTimePeriods(this.timePeriodsTranslated(timePeriods))
    this.$log.info(`-${this.dashboardId} dashboard filters component created-`)
    this.$log.info('Initializing filters', initFilters)
    this.setInitialSelectedFilters(initFilters)
    this.resetFilters()
    // fetch filters data
    // TODO - set auto updateFilters if timePeriod not set
    // this.updateFilters() // enable if no default timePeriod set
    this.renderFilters = true
  },
  methods: {
    ...mapMutations({
      setInitialSelectedFilters: 'GEN_SET_INITIAL_SELECTED_FILTERS',
      // disabled filters mutations
      setItemStatus: 'GEN_SET_ITEM_FILTER_STATUS',
      // set dashboard as generic
      setGeneric: 'GEN_SET_GENERIC',
      // set time periods
      setTimePeriods: 'GEN_SET_TIMEPERIODS'
    }),
    ...mapActions([
      // fetch filters actions
      'fetchDataGen',
      'fetchAnyTimeGen'
    ]),
    updateFilters () {
      const requestPayloadData = {
        filters: this.selectedFiltersGen,
        dashboardId: this.dashboardId
      }
      // fetch filters
      initFilters.forEach(val => {
        if (val.queryKey) {
          if (val.type === 'time') {
            this.fetchAnyTimeGen({ selected: requestPayloadData, filterId: val.outputId, filterKey: val.queryKey })
          } else {
            this.fetchDataGen({ selected: requestPayloadData, filterId: val.outputId, filterKey: val.queryKey })
          }
        }
      })
    },
    applyFilters () {
      this.$emit('apply-filters')
    },
    resetFilters () {
      this.$store.commit('GEN_RESET_FILTERS', initFilters)
    },
    clearFilters () {
      // reset filters to init state
      this.resetFilters()
      // set disabled states to false
      initFilters.forEach(val => {
        this.setItemStatus(val.outputId, true)
      })
      this.updateFilters()
      // emit event for fetching data with selected filters
      this.$emit('clear-filters')
    },
    timePeriodsTranslated (periods) {
      let translatedTimePeriods = periods.map(timePeriod => {
        timePeriod.name = this.translation(timePeriod.name)
        return timePeriod
      })
      return translatedTimePeriods
    }
  },
  beforeDestroy () {
    this.$log.info(`-${this.dashboardId} filters before destroyed-`)
    this.resetFilters()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .v-btn {
    border-radius: 4px;
    text-transform: none;
    min-width: 200px;
  }
  .v-expansion-panel {
    .v-expansion-panel__container {
      border-bottom: 1px solid rgba(0,0,0,.42);
      &:hover {
        border-bottom: 1px solid rgba(0,0,0,1);
      }
      &.v-expansion-panel__container--active {
        border-bottom: 1px solid #009aff;
        .panel--header {
          color: #009aff;
        }
      }
    }
    .v-expansion-panel__header {
      padding: 12px 16px !important;
      background: #f5f5f5;
    }
  }
</style>
